import React, { useEffect, useState } from "react";

import { Avatar, Badge, Rate, Table } from "antd";

import pastaSvg from "../../../assets/icons/infoPasta.svg";
import infoArquivoSvg from "../../../assets/icons/infoArquivo.svg";
import favoritoSvg from "../../../assets/icons/iconFavoritado.svg";

import "./styles.scss";
import { Pagination, PaginationItem } from "@mui/material";

const Listagem = ({ data, buscarPastasFilhas, handleSelectRowClick }) => {
  const [selecionado, setSelecionado] = useState("");
  const [page, setPage] = useState(1);

  const [inputPagination, setInputPagination] = useState(1);
  const columns = [
    {
      title: (
        <svg
          width="19"
          height="16"
          viewBox="0 0 19 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.13041 15.8983C9.2405 15.9652 9.36877 16.0005 9.49969 16C9.63094 16.0003 9.75945 15.9645 9.86959 15.8971C11.596 14.8398 13.2147 13.6332 14.7047 12.2929C17.4964 9.75541 18.9415 7.34873 19 5.1426V5.13969V5.00483C18.9999 3.95944 18.6533 2.94032 18.0088 2.09048C17.3643 1.24064 16.4542 0.602738 15.4063 0.266297C14.3584 -0.070143 13.2253 -0.0882356 12.166 0.214559C11.1066 0.517354 10.1743 1.12584 9.49969 1.95462C8.82499 1.126 7.89255 0.517697 6.83322 0.215079C5.77388 -0.087539 4.64081 -0.0692876 3.59301 0.267272C2.54522 0.603832 1.63528 1.24181 0.990889 2.09168C0.346496 2.94155 -6.44033e-06 3.96065 0 5.00599V5.13446V5.14376C0.0584691 7.34814 1.50357 9.75483 4.29532 12.2941C5.78529 13.6344 7.40395 14.841 9.13041 15.8983Z"
            fill="#ccc"
          />
        </svg>
      ),
      dataIndex: ["ehFavorito"],
      key: "id",
      render: (text, record) => {
        if (record.ehFavorito) {
          return (
            <span onClick={() => handleSelectRowClick(record.id, record.tipo)}>
              <Avatar className="avatar-custom-list">
                <span style={{ color: "gray" }}>.</span>
              </Avatar>
            </span>
          );
        } else {
          return (
            <span onClick={() => handleSelectRowClick(record.id, record.tipo)}>
              <Avatar className="avatar-custom-list">
                <span style={{ color: "gray" }}>.</span>
              </Avatar>
            </span>
          );
        }
      },
    },
    {
      title: "Nome",
      dataIndex: ["ehFavorito", "nome", "tipo", "extensao", "urlPreview", "id"],
      key: "id",
      render: (text, record) => {
        if (record.tipo == 0) {
          return (
            <span onClick={() => handleSelectRowClick(record.id, record.tipo)}>
              <img src={pastaSvg} />
              <span style={{ marginLeft: "1rem" }}>{record.nome}</span>
            </span>
          );
        } else {
          if (record.urlPreview) {
            return (
              <span
                onClick={() => handleSelectRowClick(record.id, record.tipo)}
              >
                <img
                  style={{ width: "1.5rem", height: "1.5rem" }}
                  src={record.urlPreview}
                />
                <span style={{ marginLeft: "1rem" }}>{record.nome}</span>
              </span>
            );
          } else {
            return (
              <span
                onClick={() => handleSelectRowClick(record.id, record.tipo)}
              >
                <img
                  style={{ width: "1.5rem", height: "1.5rem" }}
                  src={infoArquivoSvg}
                />
                <span style={{ marginLeft: "1rem" }}>{record.nome}</span>
              </span>
            );
          }
        }
      },
    },
    {
      title: "Tamanho",
      dataIndex: ["tamanho", "id"],
      key: "id",
      render: (text, record) => {
        if (record.tamanho > 0) {
          return (
            <span onClick={() => handleSelectRowClick(record.id, record.tipo)}>
              {text}
            </span>
          );
        } else {
          return (
            <span onClick={() => handleSelectRowClick(record.id, record.tipo)}>
              -
            </span>
          );
        }
      },
    },
    {
      title: "Tipo",
      dataIndex: ["tipo", "id"],
      key: "id",
      render: (text, record) => {
        if (record.tipo == 0) {
          return (
            <span onClick={() => handleSelectRowClick(record.id, record.tipo)}>
              Pasta
            </span>
          );
        } else {
          return (
            <span onClick={() => handleSelectRowClick(record.id, record.tipo)}>
              Arquivo
            </span>
          );
        }
      },
    }, 
  ];
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    const startIndex = (page - 1) * 5;
    const endIndex = startIndex + 5;
    const slicedData = data?.lista?.slice(startIndex, endIndex);
    setTableData(slicedData);
  }, [data?.lista, page]); 

  const clickRow = (record) => { 
    setSelecionado(record.id);
  };

  const formatarData = (value) => {
    if (value) {
      const data = new Date(value);
      return data.toLocaleDateString("pt-BR", { timeZone: "UTC" });
    }
  };

  const changeInputPagination = (value) => {
    setInputPagination(value === "" ? "" : Number(value));
    setPage(value === "" ? 1 : Number(value));
  };

  useEffect(() => {
    setInputPagination(page);
  }, [page]);

  const handleChange = (e, p) => {
    setPage(p);
  };
  const renderPaginationButtons = () => {
    const pageCount = Math.ceil(data?.lista?.length / 5);
    const paginationButtons = [];

    for (let i = 1; i <= pageCount; i++) {
      paginationButtons.push(
        <PaginationItem
          key={i}
          className={page === i ? "selected-pageNoti" : ""} 
          onClick={(event) => handleChange(event, i)}
        >
          {i}
        </PaginationItem>
      );
    }

    return paginationButtons;
  };

  return (
    <div className="col-lg-12  p-0">
      <Table
        rowClassName={(record) =>
          record.id == selecionado ? "selected-row-link" : ""
        }
        columns={columns}
        className="tabelaListagem"
        dataSource={tableData}
        onRow={(r) => ({
          onClick: (e) => clickRow(r),
        })}
      />
      <div className="row">
        <div
          className="col-12 p-0 mt20"
          style={{ display: "flex", justifyContent: "end" }}
        >
          <Pagination
            count={Math.ceil(data?.lista?.length / 5)}
            defaultPage={1}
            variant="outlined"
            shape="rounded"
            onChange={handleChange}
            color="secondary"
            page={page}
          >
            {renderPaginationButtons()}
          </Pagination>
          <div className="div-iput-page">
            <input
              className="input-pagination"
              onChange={(e) => changeInputPagination(e.target.value)}
              type="number"
              value={inputPagination}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Listagem;
